/**
 * Get the user's time zone. Fallback to UTC if there is an error.
 */
export const getTimeZone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
        return "UTC";
    }
};
